import apiService from '../apiService'

const apiPath = '/banner'

export const bannerController = (configService) => {
	const service = apiService(configService)
	return {
		getHomeBanner: (cuscode = '') => {
			return service.get({
				url: `${apiPath}/home?cuscode=${encodeURIComponent(cuscode)}`,
			})
		},
	}
}
